// extracted by mini-css-extract-plugin
export default {"mn-header-breadcrumb":"index_mn-header-breadcrumb__Ik3at"};